import { Text, Title } from "@src/appV2/redesign/system/ui-components";

export function NfcDisabledContent(): JSX.Element {
  return (
    <>
      <Title variant="h2" component="h1">
        NFC disabled
      </Title>

      <Text bold>NFC is disabled on your device.</Text>
      <Text bold>You must enable NFC in order to clock in/out.</Text>
    </>
  );
}
